import React, { PureComponent } from 'react'
import { string } from 'prop-types'
import { Text, Flex, Image, Box } from '@chakra-ui/react'
import cx from 'classnames'

import { Left } from 'src/components/Layout/Header'
import SvgIcon from 'src/components/SvgIcon'
import { WidgetContext } from 'src/modules/App/WidgetContext'

import styles from './HeaderMain.module.less'

class HeaderMain extends PureComponent {
  static propTypes = {
    title: string,
  }

  static defaultProps = {
    title: null,
  }

  closeWidget = () => {
    const { handleCloseWidget } = this.props

    if (typeof handleCloseWidget === 'function') {
      handleCloseWidget()
    }
  }

  render() {
    const { title, brand, isWidgetFullSize, isHome } = this.props

    const pageTitle = title || brand.name

    const classNames = cx({
      [styles.header]: true,
      [styles.notOnHomePage]: isHome !== true,
      [styles.hasBackgroundImage]: brand.headerBgImage,
      'kiosk--chakra-colors-background-primary': true,
    })

    const classNameTitle = cx({
      [styles.headerWidgetTitle]: !!isWidgetFullSize,
    })

    return (
      <Box className={classNames} style={{ backgroundImage: `url('${brand.headerBgImage}')` }}>
        {brand.headerBgImage ? (
          <Box
            pos='absolute'
            h={'100%'}
            w={'100%'}
            className='kiosk--chakra-colors-background-primary'
            opacity={0.5}
          />
        ) : null}
        <Left className={styles.headerLeft}>
          {isWidgetFullSize && (
            <SvgIcon
              type='RemoveThinner'
              onClick={this.closeWidget}
              className={cx({
                [styles.closeWidgetIcon]: true,
                'kiosk-color--brand-contrast-color': true,
              })}
            />
          )}
          <Flex
            pl={{ base: 0, desktop: '100px' }}
            justify={{ base: 'center', desktop: 'flex-start' }}
          >
            {brand.logo ? (
              <Image maxH='60px' boxSize='200px' objectFit='contain' src={brand.logo} alt='logo' />
            ) : (
              <Text
                className={classNameTitle}
                fontSize={'34px'}
                variant='contrast'
                align={{ base: 'center', desktop: 'left' }}
              >
                {pageTitle}
              </Text>
            )}
          </Flex>
        </Left>
      </Box>
    )
  }
}

const HeaderMainContext = props => (
  <WidgetContext.Consumer>
    {context => <HeaderMain {...props} {...context} />}
  </WidgetContext.Consumer>
)

export default HeaderMainContext
